import Dropdown from '../../ui/Dropdown/Dropdown';
import { StatsCard } from '../../ui/StatsCard/StatsCard';
import { StatsSectionProps } from './StatsSection.types';

export function StatsSection({
  totalSystems,
  complianceData,
  regulationOptions,
  selectedRegulation,
  onRegulationChange,
}: StatsSectionProps) {
  return (
    <div className="flex flex-col sm:flex-row items-stretch gap-4 w-full">
      <div className="w-full sm:w-4/12">
        <StatsCard title="Regulation">
          <Dropdown
            placeholder="Select regulation"
            options={regulationOptions}
            value={selectedRegulation}
            onChange={onRegulationChange}
            size="sm"
            buttonClassName="!border-0 !shadow-none !ring-0 h-10 px-0 py-0"
            placeholderClassName="text-sm leading-5 font-medium text-gray-900v2"
          />
        </StatsCard>
      </div>
      <div className="w-full sm:w-2/12 2xl:w-3/12">
        <StatsCard title="Total" variant="simple" value={totalSystems} />
      </div>
      <div className="w-full sm:w-6/12 2xl:w-5/12">
        <StatsCard
          title="Compliance Status"
          variant="breakdown"
          items={[
            { label: 'Compliant', value: complianceData.compliant },
            { label: 'In Progress', value: complianceData.inProgress },
            { label: 'Non Compliant', value: complianceData.nonCompliant },
          ]}
        />
      </div>
    </div>
  );
}
